import type { LyricInput } from '@creanizer/types'
import { Label } from '@creanizer/ui'
import { Textarea } from '@creanizer/ui'

interface QuickInputProps {
  input: LyricInput
  onChange: (input: LyricInput) => void
}

export function QuickInput({ input, onChange }: QuickInputProps) {

  return (
    <div className="space-y-6">
      {/* クイック入力エリア */}
      <div className="space-y-2">
        <Label htmlFor="quick-prompt">
          🎵 歌詞のアイデアを入力
        </Label>
        <Textarea
          id="quick-prompt"
          placeholder={`例：
• 夏の恋愛ソングを作って
• 希望に満ちた卒業ソング
• 失恋から立ち直る前向きな歌
• ファンタジー世界の冒険者の歌
• 青春時代の友情を歌った曲
• 雨の日の切ない気持ち
• 未来への希望を歌うロック`}
          value={input.quickPrompt || ''}
          onChange={(e) => onChange({ ...input, quickPrompt: e.target.value })}
          className="min-h-[150px] text-base font-sans"
        />
        <p className="text-sm text-muted-foreground">
          自由に書いてください。AIが意図を理解して最適な歌詞を生成します
        </p>
      </div>

      {/* 追加のヒント */}
      <div className="rounded-lg border border-blue-200 bg-blue-50 p-4">
        <h4 className="font-semibold text-blue-900 mb-2">
          💡 ヒント
        </h4>
        <ul className="text-sm text-blue-800 space-y-1">
          <li>• ジャンル、雰囲気、テーマを組み合わせると効果的です</li>
          <li>• 具体的なシーンや感情を書くとより良い結果が得られます</li>
          <li>• 言語を混ぜたい場合は「日本語と英語を混ぜて」と書いてください</li>
          <li>• BPMやリズムの希望があれば書いてください（例：「アップテンポで」）</li>
        </ul>
      </div>
    </div>
  )
}